/**
 * PATH: packages/email-hub/src/feature/pages/inbox-page/helpers.ts
 * FILE_ID: EMAILHUB-INBOX-HELPERS-065
 * PURPOSE: Pure folder and sender-domain projections used by InboxPage.
 */

import type { EmailFolderKind } from './contracts'

const GENERIC_EMAIL_DOMAINS = new Set<string>([
  'gmail.com', 'googlemail.com', 'outlook.com', 'hotmail.com', 'live.com',
  'msn.com', 'yahoo.com', 'yahoo.com.au', 'ymail.com', 'icloud.com',
  'me.com', 'mac.com', 'aol.com', 'proton.me', 'protonmail.com',
  'bigpond.com', 'bigpond.net.au', 'optusnet.com.au', 'iinet.net.au',
  'tpg.com.au', 'internode.on.net',
])

export const FOLDER_TITLES: Record<EmailFolderKind, string> = {
  inbox: 'Inbox',
  sent: 'Sent',
  archived: 'Archived',
  starred: 'Starred',
  binned: 'Binned',
}

/** Lower-cased domain part of an email address, or '' when absent. */
export function domainOf(address?: string | null): string {
  if (!address) return ''
  const at = address.lastIndexOf('@')
  return at >= 0 ? address.slice(at + 1).trim().toLowerCase() : ''
}

/** Friendly company label from a non-generic sender domain. */
export function companyLabelFromAddress(address?: string | null): string {
  const domain = domainOf(address)
  if (!domain || GENERIC_EMAIL_DOMAINS.has(domain)) return ''
  const stem = domain.split('.')[0] || domain
  return stem.charAt(0).toUpperCase() + stem.slice(1)
}

/**
 * Shared inbox "filter to this company" action (P23). Clears the person-from
 * scope, sets company domain (+ optional label), and closes the reader.
 */
export function applyCompanyFilter(opts: {
  domain: string
  label?: string
  setFromAddressContains: (v: string) => void
  setCompanyDomain: (domain: string, label?: string) => void
  setSelectedEmailId: (id: string | null) => void
}): void {
  const domain = (opts.domain || '').trim().toLowerCase()
  if (!domain) return
  opts.setFromAddressContains('')
  opts.setCompanyDomain(domain, opts.label)
  opts.setSelectedEmailId(null)
}
